import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconArchive, IconArchiveOff } from '@tabler/icons-react';

import { useArchivePage } from '../../../../api';
import { Platform } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

type ArchiveButtonProps = {
  pageId: string;
  platform: Platform;
  isArchived: boolean;
  isRestoring?: boolean;
};

export const ArchiveButton = ({
  pageId,
  platform,
  isArchived,
  isRestoring,
}: ArchiveButtonProps) => {
  const archive = useArchivePage();

  if (isRestoring) {
    return (
      <Tooltip label="Data is being restored from archive...">
        <ActionIcon loading color="orange" radius="md" style={{ alignSelf: 'flex-start' }}>
          <IconArchiveOff />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (isArchived) {
    return (
      <Tooltip label="Unarchive Page">
        <ActionIcon
          loading={archive.isLoading}
          color="teal"
          onClick={() =>
            NiceModal.show(ConfirmModal, {
              title: 'Unarchive page? This will restore all dialogs and messages from archive.',
              onSuccess: () => archive.mutate({ pageId, platform, isArchived: false }),
            })
          }
          radius="md"
          style={{ alignSelf: 'flex-start' }}
        >
          <IconArchiveOff />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Archive Page">
      <ActionIcon
        variant="filled"
        loading={archive.isLoading}
        onClick={() =>
          NiceModal.show(ConfirmModal, {
            title: 'Archive page? All dialogs and messages will be moved to cold storage.',
            onSuccess: () => archive.mutate({ pageId, platform, isArchived: true }),
          })
        }
        radius="md"
        style={{ alignSelf: 'flex-start' }}
      >
        <IconArchive />
      </ActionIcon>
    </Tooltip>
  );
};
